module.exports = __webpack_public_path__ + "img/PF.654a9382.png";